module.exports = __webpack_public_path__ + "img/mmdc-k.faeb093f.png";